import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const TesterPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const turningOff = searchParams.has('off');
    const [error, setError] = useState(null);

    useEffect(() => {
        try {
            if (turningOff) {
                localStorage.removeItem('TesterMode');
            } else {
                localStorage.setItem('TesterMode', 'yes');
            }
        } catch (e) {
            setError(String(e));
        }
    }, [turningOff]);

    const isOn = !turningOff;

    const btnStyle = {
        marginTop: '1.25rem',
        padding: '.75rem 2rem',
        borderRadius: '999px',
        border: 'none',
        background: '#111',
        color: 'white',
        fontSize: '1rem',
        fontWeight: '700',
        cursor: 'pointer',
        letterSpacing: '.04em',
    };

    return (
        <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            minHeight: '100vh', background: '#F9F9F9', padding: '1rem',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        }}>
            <div style={{
                background: 'white', borderRadius: '16px', padding: '2rem',
                boxShadow: '0 4px 20px rgba(0,0,0,.12)', textAlign: 'center',
                width: '100%', maxWidth: '420px',
            }}>
                {error ? (
                    <>
                        <h2 style={{ color: '#c00', fontSize: '1.4rem', margin: '0 0 .75rem' }}>
                            ✗ Could not update TesterMode
                        </h2>
                        <p style={{ color: '#555', fontSize: '1rem' }}>{error}</p>
                    </>
                ) : isOn ? (
                    <>
                        <h2 style={{ color: '#2d7a2d', fontSize: '1.4rem', margin: '0 0 .75rem' }}>
                            ✓ Tester Mode Active
                        </h2>
                        <p style={{ color: '#444', fontSize: '1rem', lineHeight: 1.5, margin: '.5rem 0' }}>
                            <code style={{ background: '#eee', padding: '2px 7px', borderRadius: '4px' }}>TesterMode</code>
                            {' '}has been set to{' '}
                            <code style={{ background: '#eee', padding: '2px 7px', borderRadius: '4px' }}>"yes"</code>
                            {' '}in this browser.
                        </p>
                        <div style={{
                            background: '#fff8e1', borderLeft: '4px solid #f5a623',
                            borderRadius: '8px', padding: '.75rem 1rem',
                            margin: '1rem 0', textAlign: 'left',
                            fontSize: '.95rem', color: '#555', lineHeight: 1.5,
                        }}>
                            Conversations from this browser will <strong>not</strong> be
                            monitored — to avoid clutter in the logs.
                            <br />
                            To turn off: navigate to <code style={{ background: '#eee', padding: '1px 5px', borderRadius: '3px' }}>/tester?off</code>
                        </div>
                        <button onClick={() => navigate('/chat', { replace: true })} style={btnStyle}>
                            Continue
                        </button>
                    </>
                ) : (
                    <>
                        <h2 style={{ color: '#b04a00', fontSize: '1.4rem', margin: '0 0 .75rem' }}>
                            ✗ Tester Mode Off
                        </h2>
                        <p style={{ color: '#444', fontSize: '1rem', lineHeight: 1.5, margin: '.5rem 0' }}>
                            <code style={{ background: '#eee', padding: '2px 7px', borderRadius: '4px' }}>TesterMode</code>
                            {' '}has been removed. Conversations will be monitored normally.
                        </p>
                        <button onClick={() => navigate('/chat', { replace: true })} style={btnStyle}>
                            Continue
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default TesterPage;
